export type WorkflowSortField = 'name' | 'created_at' | 'updated_at'
export type WorkflowSortDirection = 'asc' | 'desc'

export interface WorkflowSortState {
  field: WorkflowSortField
  direction: WorkflowSortDirection
}

export const DEFAULT_WORKFLOW_SORT: WorkflowSortState = {
  field: 'updated_at',
  direction: 'desc'
}

export const toWorkflowOrdering = ({ field, direction }: WorkflowSortState): string =>
  direction === 'desc' ? `-${field}` : field
